module.exports = __webpack_public_path__ + "static/media/handloop.b56dc842.png";